import { createGlobalStyle } from 'styled-components';

export const ScrollbarGutterStyle = createGlobalStyle`
  html {
    scrollbar-gutter: stable;
  }

  body {
    background-color: ${({ theme }) => theme.colors.canvas};
  }
`;
